import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';

import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import {
  AuthConfig, NullValidationHandler, OAuthModule, OAuthService, OAuthStorage, ValidationHandler,
} from 'angular-oauth2-oidc';
import { Mdb5AdaptedModule, MdbLoadingModule, MdbModalRef, MdbModalService, MdbPopoverModule } from 'mdb5-adapted';
import { NgxPaginationModule } from 'ngx-pagination';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { ClientSearchModule } from 'src/app/client-search/client-search.module';
import { HttpErrorInterceptor, TRACKREQ_ENABLED } from 'src/app/core/interceptors/http-error.interceptor';
import { BranchEmployersModule } from 'src/app/features/branch-employers/branch-employers.module';
import { RatesAndFeesModule } from 'src/app/modules/rates-and-fees/rates-and-fees.module';
import { RegionsAdminModule } from 'src/app/modules/regions-admin/regions-admin.module';
import { environment } from 'src/environments/environment';

import { LMSSharedUiModule } from '@lmsSharedUI';

import { AppComponent } from './app.component';
import { authConfig } from './auth-config.module';
import { initializeAppAuth } from './core/auth/app-auth.initializer';
import { LMSDatePickerModule } from './core/constants/datepicker-adapter';
import { LoaderInterceptor } from './core/interceptors/loading.interceptor';
import { RoleInterceptor } from './core/interceptors/role.interceptor';
import { DEFAULT_TIMEOUT, TimeoutInterceptor } from './core/interceptors/timeout.interceptor';
import { RestServicesModule } from './core/rest-services/rest-services.module';
import { AUTO_LOGOUT, AutoLogoutService } from './core/services/auto-logout.service';
import { UserService } from './core/services/lmsuser.service';
import { _window, WINDOW } from './core/services/window.token';
import { LandingModule } from './landing/landing.module';
import { NavigationModule } from './navbar/navigation.module';
import { AnnouncementBannerComponent } from './shared/announcement-banner/announcement-banner.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { MainLayoutComponent } from './shared/components/main-layout/main-layout.component';
import { LMSDialogHandlerService } from './shared/lmsdialog-handler.service';
import { LoadingSpinModule } from './shared/loaders';
import { ApiloaderService } from './shared/loaders/apiloader/apiloader.service';

@NgModule({
  declarations: [AppComponent, MainLayoutComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [
          environment.apiUrl,
          environment.apiDocUrl,
          environment.apiBioUrl,
          environment.keycloakHost,
          '/uuid',
          '/getUserMenus',
        ],
        sendAccessToken: true,
      },
    }),
    HttpClientModule,
    Mdb5AdaptedModule,
    MdbLoadingModule,
    LoadingSpinModule,
    NavigationModule,
    //CachingModule,
    FormsModule,
    HeaderComponent,
    NgxPaginationModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      registrationStrategy: 'registerWhenStable:10000',
      enabled: environment.serviceWorker,
    }),
    BackButtonDisableModule.forRoot(),
    RestServicesModule,
    LMSSharedUiModule,
    MdbPopoverModule,
    MdbLoadingModule,
    ToastrModule.forRoot({
      timeOut: 8000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      closeButton: true,
      progressBar: true,
      newestOnTop: true,
      maxOpened: 5,
      autoDismiss: true,
      enableHtml: true,
      tapToDismiss: true,
    }),
    BranchEmployersModule,
    RegionsAdminModule,
    // RegionalManagerModule,
    ClientSearchModule,
    RatesAndFeesModule,
    LMSDatePickerModule,
    ReactiveFormsModule,
    LandingModule,
    AnnouncementBannerComponent,
  ],
  providers: [
    { provide: DEFAULT_TIMEOUT, useValue: 120000 },
    { provide: TRACKREQ_ENABLED, useValue: true },
    { provide: AUTO_LOGOUT, useValue: 420000 }, // 60000 * 7 = 7 minutes
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppAuth,
      deps: [OAuthService, UserService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      deps: [ApiloaderService],
      multi: true, // Allows multiple interceptors
    },
    { provide: ValidationHandler, useClass: NullValidationHandler },
    { provide: AuthConfig, useValue: authConfig },
    { provide: OAuthStorage, useValue: localStorage },
    { provide: HTTP_INTERCEPTORS, useClass: RoleInterceptor, multi: true },
    //{ provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true },
    // provideHttpClient(withInterceptorsFromDi(
    // )),
    LMSDialogHandlerService,
    AutoLogoutService,
    { provide: MdbModalRef, useExisting: MdbModalService, multi: true },
    { provide: LOCALE_ID, useValue: 'en-ZA' },
    { provide: WINDOW, useFactory: _window },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
